import { Component, OnInit } from '@angular/core';
import { EventsManager } from "../../events/events.manager";
import { Router, ActivatedRoute } from '@angular/router';
import { SmartSearchConfig, GroupCodeService } from '@wellfit-tech/wf-plans-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ancillary-search',
  templateUrl: './ancillary-search.component.html',
  styleUrls: ['./ancillary-search.component.scss']
})
export class AncillarySearchComponent implements OnInit {
  ancillaryCodes: string = '';
  isConfigReady: boolean = false;
  searchConfig: SmartSearchConfig = {
    bootstrapVersion: '4',
    environment: (environment.smartSearchEnvironment === 'production') ? 'production' : 'staging',
    memberId: 0,
    isMember: false,
    groupCode: '' // Will be determined by GroupCodeService
  };

  constructor(
    public em: EventsManager, 
    private router: Router,
    private route: ActivatedRoute,
    private groupCodeService: GroupCodeService
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    
    // Check query parameters for configuration
    this.route.queryParams.subscribe(params => {
      const groupCodeFromQuery = params['groupCode'];
      
      // Use query parameters if available, otherwise fall back to EventsManager
      if (groupCodeFromQuery) {
        this.configureSearchWithGroupCode(groupCodeFromQuery);
      } else {
        this.configureSearchFromEventsManager();
      }
    });
  }

  private configureSearchWithGroupCode(groupCode: string): void {
    this.searchConfig = {
      memberId: 0,
      isMember: false,
      environment: (environment.smartSearchEnvironment === 'production') ? 'production' : 'staging',
      bootstrapVersion: '4',
      groupCode: groupCode
    };
    
    this.setConfigReady();
  }

  private configureSearchFromEventsManager(): void {
    // Get the ancillary codes from the events manager
    const planDetailInfo = this.em.planDetailInfo;
    
    if (planDetailInfo && planDetailInfo.templateId) {
      const template = this.em.officeInfo?.benefitPlanTemplates?.find((t: any) => 
        t.benefitPlanTemplateId == planDetailInfo.templateId
      );
      
      this.ancillaryCodes = template?.ancillaryBenefits || '';
      
      // Determine group code using the service
      const groupCode = this.groupCodeService.determineGroupCode(this.ancillaryCodes);
      
      this.searchConfig = {
        memberId: 0,
        isMember: false,
        environment: environment.production ? 'production' : 'staging',
        bootstrapVersion: '4',
        groupCode: groupCode
      };
      
      this.setConfigReady();
    } else {
      this.setConfigReady();
    }
  }

  private setConfigReady(): void {
    setTimeout(() => {
      this.isConfigReady = true;
    }, 100);
  }

  goBack(): void {
    this.router.navigate(['/ancillary-benefits']);
  }
}
